module.exports = __webpack_public_path__ + "static/pic01.55e1797f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/pic01.jpg
// module id = 483
// module chunks = 114276838955818